import 'css-chunksrc/client/common/resourceSelection/styles.scss';export default {
  "resourcesSelection": "_resourcesSelection_1bt3w_1",
  "root": "_root_1bt3w_12",
  "search": "_search_1bt3w_18",
  "list": "_list_1bt3w_22"
};